// @ts-nocheck
import React, { useEffect, useState } from "react";
import {
  SimpleForm,
  required,
  useListContext,
  useNotify,
  Create,
  useRedirect,
  SelectInput,
  TextInput,
  useGetList,
  ImageInput,
  ImageField,
  Loading,
  Error,
  useDataProvider,
  SaveButton,
  Toolbar,
  FormDataConsumer,
} from "react-admin";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import _ from "lodash";
import { useMutation } from "react-query";

const CustomToolbarNoDelete = ({ dataForm, extData }: any) => {
  console.log(dataForm, "TEST");

  console.log(extData?.length, "length");

  const tempFormData = Object.keys(dataForm).forEach(
    (key) => !dataForm[key] && delete dataForm[key]
  );

  const notify = useNotify();
  const redirect = useRedirect();

  const dataProvider = useDataProvider();
  const { mutate, isLoading, isSuccess } = useMutation(() =>
    dataProvider.create("diasporaHoliday", {
      data: { ...dataForm, priority: extData?.length + 1 },
    })
  );
  const [eq, setEq] = useState(true);
  useEffect(() => {
    const equal = _.isEqual(dataForm, {});
    setEq(equal);
  }, [dataForm]);

  useEffect(() => {
    if (isSuccess) {
      notify("ra.notification.created", "info", { smart_count: 1 });
      redirect("/diasporaHoliday");
    }
  }, [isSuccess]);
  return (
    <Toolbar classes={useStyles()}>
      <SaveButton
        onClick={(event) => {
          if (Object.keys(dataForm).length === 3) {
            event.preventDefault();
            mutate();
          }
        }}
        data-test-id="save_btn"
        disabled={eq}
      />
    </Toolbar>
  );
};

const CreatePage = (props: any) => {
  const listData = useListContext();

  const classes = useStyles();

  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = () => {
    notify("ra.notification.created", "info", { smart_count: 1 });
    redirect("/diasporaHoliday");
  };
  const { data, isLoading, error } = useGetList("diasporaHoliday");

  const countryList = [
    { id: "GLOBAL", name: "Worldwide" },
    { id: "HK", name: "Hong Kong" },
    { id: "ID", name: "Indonesia" },
    { id: "MY", name: "Malaysia" },
    { id: "TW", name: "Taiwan" },
  ];
  // const postDefaultValue = () => ({ total: data?.total });
  const [dataForm, setDataForm] = useState({});
  return (
    <Create
      {...props}
      title="Diaspora Holiday &gt; Add"
      mutationOptions={{
        onSuccess: onSuccess,
      }}
    >
      <SimpleForm
        toolbar={
          <CustomToolbarNoDelete
            dataForm={dataForm}
            extData={!isLoading && !error && data}
          />
        }
      >
        <div className={classes.root}>
          <div className={classes.form}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <SelectInput
                  data-test-id="country_select"
                  fullWidth
                  className={classes.input}
                  source="country_code"
                  validate={[required()]}
                  choices={countryList}
                  label="Country"
                />
              </Grid>
              <Grid item xs={6}>
                <TextInput
                  data-test-id="title_input"
                  fullWidth
                  validate={[required()]}
                  source="date"
                  label="Title (Date)"
                />
              </Grid>
              <Grid item xs={6}>
                <ImageInput
                  source="thumbnail"
                  label="Thumbnail"
                  accept="image/*"
                  options={{ multiple: false }}
                >
                  <ImageField source="src" title="title" />
                </ImageInput>
              </Grid>
            </Grid>
            <FormDataConsumer>
              {({ formData, ...rest }) => {
                setDataForm(formData);
              }}
            </FormDataConsumer>
          </div>
        </div>
      </SimpleForm>
    </Create>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
  },
  form: {
    flexGrow: 1,
  },
  input: {
    marginBottom: "-20px ",
  },
  text: {
    color: "#0000008A",
  },
}));

export default CreatePage;
